const HorizontalRule = () => {
    return(<div className="horizontal_rule"> </div>)
}

export default HorizontalRule;